import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextInputHighlightComponent } from './text-input-highlight.component';
import { TextInputHighlightContainerDirective } from './text-input-highlight-container.directive';
import { TextInputElementDirective } from './text-input-element.directive';

@NgModule({
  declarations: [
    TextInputHighlightComponent,
    TextInputHighlightContainerDirective,
    TextInputElementDirective
  ],
  imports: [CommonModule],
  exports: [
    TextInputHighlightComponent,
    TextInputHighlightContainerDirective,
    TextInputElementDirective
  ]
})
export class TextInputHighlightModule {}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/text-input-highlight.module.ts